import { memo, useContext } from 'react';

import { Image } from '@/shared/ui';

import { BlockTitle } from '@/components/old';

import ModalContext from '../../../contexts/Modal/ModalContext';
import { Button } from '../../Button';
import { ModalBorderTopColor, ModalConstructor } from '../ModalConstructor';

import './InsurancePhoneChangeAlert.scss';

export interface InsurancePhoneChangeAlertProps {
  onStay?: () => void;
  onLeave: () => void;
}

export const InsurancePhoneChangeAlert = memo<InsurancePhoneChangeAlertProps>(function ({ onStay, onLeave }) {
  const { toggleModal } = useContext(ModalContext);

  return (
    <ModalConstructor modalBorderTopColor={ModalBorderTopColor.yellow}>
      <div className="insurance-phone-change-alert">
        <div className="insurance-phone-change-alert__title">
          <Image src="/images/attention_grey.svg" alt="attention grey" />
          <BlockTitle withoutBaseStyles>Увага! При зміні номера телефона буде сформована нова оферта</BlockTitle>
        </div>

        <div className="insurance-phone-change-alert__body">Введені дані на попередніх кроках будуть збережені</div>

        <div className="insurance-phone-change-alert__buttons-box">
          <Button
            onClick={(): void => {
              onStay && onStay();
              toggleModal(false);
            }}
          >
            Скасувати
          </Button>

          <Button
            outline
            onClick={(): void => {
              onLeave();
              toggleModal(false);
            }}
          >
            Редагувати
          </Button>
        </div>
      </div>
    </ModalConstructor>
  );
});
